/** @jsxImportSource @emotion/react */
import { Breadcrumbs, Anchor, Text, useMantineTheme, Divider } from "@mantine/core";
import { Link, To } from "react-router-dom";
import { IconArrowRight, IconArrowRightRhombus, IconHome, IconLogin, IconLogout2, IconMathGreater } from "@tabler/icons-react";
import styled from "@emotion/styled";

// Breadcrumb link type (path is optional for last item)
export interface BreadcrumbLink {
  label: string;
  path?: To;
}

// Props for BenchBreadcrumbs
interface BenchBreadcrumbsProps {
  links: BreadcrumbLink[];
}

// Styled Breadcrumbs container
const StyledBreadcrumbs = styled(Breadcrumbs)`
  font-size: 18px;
  font-weight: 500;
  // margin-top: 8px;
  // margin-bottom: 16px;
`;

const BenchBreadcrumbs: React.FC<BenchBreadcrumbsProps> = ({ links }) => {
  const theme = useMantineTheme();
  return (
    <>   <StyledBreadcrumbs separator={<span style={{ fontSize: 28 }}><IconMathGreater size={23} style={{ paddingTop: 4 }} /></span>}>
      {/* Fixed Home */}
      <Anchor
        component={Link}
        to="/home"
        sx={{
          display: "flex",
          alignItems: "center",
          fontWeight: 500,
          textDecoration: "none",
        }}
      >
        <IconHome size={18} style={{}} />
      </Anchor>

      {/* Dynamic links */}
      {links.map((link, index) => {
        // If path exists, render Link; else render plain Text
        return link.path ? (
          <Anchor
            key={index}
            component={Link}
            to={link.path}
            sx={{

              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              textDecoration: "none",
              marginLeft: 1,
              "&:hover": {
                textDecoration: "none"
              }
            }}
            color="black"
          >
            {link.label}
          </Anchor>
        ) : (
          <Text
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              marginLeft: 1,
              color: theme.colors.brand[4],
              "&:hover": {
                textDecoration: "underline"

              }


            }}
          >
            {link.label}
          </Text>
        );
      })}
    </StyledBreadcrumbs>

    </>
  );
};

export default BenchBreadcrumbs;
